import { useOutletContext } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faEraser } from '@fortawesome/free-solid-svg-icons';
import { InputGroup, Input, Button } from "reactstrap";
import { useState } from "react";

import { translations } from './../i18/translations.js';

const Search = ({ placeholder, handleSearch }) => {

    const {lang} = useOutletContext();

    const [query, setQuery] = useState("");

    const onSubmitHandler = (e) => {
        e.preventDefault();
        handleSearch(query);
    };

    const clearInputHandler = () => {
        setQuery("");
        handleSearch("");
    };

    return (
            <form onSubmit={onSubmitHandler} className="d-flex" style={{width: "100%"}} id='searchForm'>            
                <InputGroup>
                    <label className="input-group-text d-block" htmlFor="searchInput">
                        <FontAwesomeIcon icon={faSearch} />
                    </label>
                    <Input
                        id="searchInput"
                        type="text"
                        placeholder={placeholder}
                        value={query}
                        maxLength="100"
                        onChange={(e) => setQuery(e.target.value)}
                        className="form-control"
                        />
                    <Button type="submit" className="btn btn-secondary" title={translations[lang].search}>
                        <FontAwesomeIcon icon={faSearch} />
                    </Button>            
                    <Button type="button" onClick={clearInputHandler} className="btn btn-secondary" title={translations[lang].reset}>
                        <FontAwesomeIcon icon={faEraser} />
                    </Button>
                </InputGroup>
            </form>
            );
};

export default Search;
